import Vue from 'vue'
import VueRouter from 'vue-router'
// import { getToken } from '../util/auth'
import MainView from '../views/MainView'
import View from '../views/View'
import workbenchRouter from '@/router/workbench'
import systemList from './module/system'
// import { normalizeToArray } from 'echarts/lib/util/model'
Vue.use(VueRouter)

export const routes = [{
  path: '/',
  redirect: '/workbench/workbenchManage/home'
},
{
  path: '/login',
  name: 'Login',
  component: () => import('@/views/LoginView')
},
{
  ...workbenchRouter
},
{
  path: '/product',
  component: MainView,
  name: 'product',
  meta: {
    title: '产品'
  },
  icon: 'el-icon-menu',
  redirect: '/product/productManage/productList',
  children: [{
    path: 'productManage',
    name: 'productManage',
    meta: {
      title: '产品管理'
    },
    redirect: '/product/productManage/productList',
    component: View,
    children: [{
      path: 'productList',
      name: 'productList',
      meta: {
        title: '产品列表'
      },
      component: () => import('@/views/product/productManage/productList')
    },
    {
      path: 'addProduct',
      name: 'addProduct',
      meta: {
        title: '添加产品'
      },
      hidden: true,
      component: () => import('@/views/product/productManage/addProduct')
    },
    {
      path: 'productDetails',
      name: 'productDetails',
      meta: {
        title: '产品详情'
      },
      component: () => import('@/views/product/productManage/productDetails')
    },
    {
      path: 'productBrandSeries',
      name: 'productBrandSeries',
      meta: {
        title: '品牌系列'
      },
      component: () => import('@/views/product/productManage/productBrandSeries')
    },
    {
      path: 'productUnit',
      name: 'productUnit',
      meta: {
        title: '计量单位'
      },
      component: () => import('@/views/product/productManage/productUnit')
    },
    {
      path: 'productClass',
      name: 'productClass',
      meta: {
        title: '产品分类'
      },
      component: () => import('@/views/product/productManage/productClass')
    }
    ]
  },
  {
    path: 'priceStrategy',
    name: 'priceStrategy',
    meta: {
      title: '价格策略'
    },
    redirect: '/product/priceStrategy/coefficientAdjustment',
    component: View,
    children: [{
      path: 'initialSetting',
      name: 'initialSetting',
      meta: {
        title: '初始系数设置'
      },
      component: () => import('@/views/product/priceStrategy/initialSetting')
    },
    {
      path: 'coefficientAdjustment',
      name: 'coefficientAdjustment',
      meta: {
        title: '系数调整'
      },
      component: () => import('@/views/product/priceStrategy/coefficientAdjustment')
    }
    ]
  }
  ]
},
{
  path: '/crm',
  component: MainView,
  name: '/crm',
  meta: {
    title: 'CRM'
  },
  icon: 'el-icon-menu',
  redirect: '/crm/customer/myCustomer',
  children: [{
    path: 'customer',
    name: 'customer',
    meta: {
      title: '客户管理'
    },
    redirect: '/crm/customer/myCustomer',
    component: View,
    children: [{
      path: 'myCustomer',
      name: 'myCustomer',
      meta: {
        title: '我的客户'
      },
      component: () => import('@/views/crm/customer/myCustomer')
    },
    {
      path: 'addCustomers',
      name: 'addCustomers',
      meta: {
        title: '添加客户'
      },
      component: () => import('@/views/crm/customer/addCustomers')
    },
    {
      path: 'details',
      name: 'customer/details', // 为了避免重复,给详情加上客户区别一下
      meta: {
        title: '客户详情'
      },
      component: () => import('@/views/crm/customer/details')
    },
    {
      path: 'special',
      name: 'special',
      meta: {
        title: '客户特价审批'
      },
      component: () => import('@/views/crm/customer/special')
    },
    {
      path: 'negotiatedPrice',
      name: 'negotiatedPrice',
      meta: {
        title: '协议价模版管理'
      },
      component: () => import('@/views/crm/customer/negotiatedPrice')
    },
    {
      path: 'tempDetails',
      name: 'tempDetails',
      meta: {
        title: '协议价模版详情'
      },
      component: () => import('@/views/crm/customer/tempDetails')
    },
    {
      path: 'templateAdd',
      name: 'templateAdd',
      meta: {
        title: '添加模板'
      },
      component: () => import('@/views/crm/customer/templateAdd')
    },
    {
      path: 'entrustedClientList',
      name: 'entrustedClientList',
      meta: {
        title: '委托客户列表'
      },
      component: () => import('@/views/crm/customer/entrustedClientList')
    },
    {
      path: 'public',
      name: 'public',
      meta: {
        title: '公共客户库'
      },
      component: () => import('@/views/crm/customer/public')
    },
    {
      path: 'transfer',
      name: 'transfer',
      meta: {
        title: '客户关系转移'
      },
      component: () => import('@/views/crm/customer/transfer')
    },
    {
      path: 'teamCustomer',
      name: 'teamCustomer',
      meta: {
        title: '团队客户库'
      },
      component: () => import('@/views/crm/customer/teamCustomer')
    },
    {
      path: 'managementSet',
      name: 'managementSet',
      meta: {
        title: '客户管理设置'
      },
      component: () => import('@/views/crm/customer/managementSet')
    }
    ]
  },
  {
    path: 'supplier',
    name: 'supplier',
    meta: {
      title: '供应商管理'
    },
    redirect: '/crm/supplier/supplierList',
    component: View,
    children: [{
      path: 'supplierList',
      name: 'supplierList',
      meta: {
        title: '我的供应商'
      },
      component: () => import('@/views/crm/supplier/supplierList')
    },
    {
      path: 'supplierAdd',
      name: 'supplierAdd',
      meta: {
        title: '添加供应商'
      },
      component: () => import('@/views/crm/supplier/supplierAdd')
    },
    {
      path: 'teamSupplierList',
      name: 'teamSupplierList',
      meta: {
        title: '团队供应商'
      },
      component: () => import('@/views/crm/supplier/teamSupplierList')
    },
    {
      path: 'supplierEdit',
      name: 'supplierEdit',
      meta: {
        title: '供应商详情'
      },
      component: () => import('@/views/crm/supplier/supplierEdit')
    },
    {
      path: 'supplierRecharge',
      name: 'supplierRecharge',
      meta: {
        title: '发起充值'
      },
      component: () => import('@/views/crm/supplier/supplierRecharge')
    },
    {
      path: 'quoteDetail',
      name: 'quoteDetail',
      meta: {
        title: '报价明细'
      },
      component: () => import('@/views/crm/supplier/quoteDetail')
    },
    {
      path: 'quoteCollect',
      name: 'quoteCollect',
      meta: {
        title: '报价管理'
      },
      component: () => import('@/views/crm/supplier/quoteCollect')
    },
    {
      path: 'quoteCollectex',
      name: 'quoteCollectex',
      meta: {
        title: '报价查询'
      },
      component: () => import('@/views/crm/supplier/quoteCollectex')
    },
    {
      path: 'quoteConfig',
      name: 'quoteConfig',
      meta: {
        title: '报价单配置'
      },
      component: () => import('@/views/crm/supplier/quoteConfig')
    },
    {
      path: 'activityList',
      name: 'activityList',
      meta: {
        title: '活动列表'
      },
      component: () => import('@/views/crm/supplier/activityList')
    },
    {
      path: 'initiatCollection',
      name: 'initiatCollection',
      meta: {
        title: '发起收款'
      },
      component: () => import('@/views/crm/supplier/initiatCollection')
    },
    {
      path: 'activityAdd',
      name: 'activityAdd',
      meta: {
        title: '添加活动'
      },
      component: () => import('@/views/crm/supplier/activityAdd')
    },
    {
      path: 'activityEdit',
      name: 'activityEdit',
      meta: {
        title: '活动详情页'
      },
      component: () => import('@/views/crm/supplier/activityEdit')
    }
    ]
  }
  ]
},
{
  path: '/sell',
  component: MainView,
  name: 'sellex',
  meta: {
    title: '销售管理'
  },
  icon: 'el-icon-menu',
  redirect: '/sell/personageManagement/sellProductsEnquiry',
  children: [{
    path: 'personageManagement',
    name: 'personageManagement',
    meta: {
      title: '个人销售'
    },
    redirect: '/sell/personageManagement/sellProductsEnquiry',
    component: View,
    children: [{
      path: 'sellProductsEnquiry',
      name: 'sellProductsEnquiry',
      meta: {
        title: '销售产品询价'
      },
      component: () => import('@/views/sell/personageManagement/sellProductsEnquiry')
    },
    {
      path: 'sellInquiryDetails',
      name: 'sellInquiryDetails',
      meta: {
        title: '询价详情'
      },
      component: () => import('@/views/sell/personageManagement/sellProductsEnquiry')
    },
    {
      path: 'inquiryList',
      name: 'inquiryList',
      meta: {
        title: '询价单列表'
      },
      component: () => import('@/views/sell/personageManagement/inquiryList')
    },
    {
      path: 'contractList',
      name: 'contractList',
      meta: {
        title: '合同列表'
      },
      component: () => import('@/views/sell/personageManagement/contractList')
    },
    {
      path: 'badDebtApplication',
      name: 'badDebtApplication',
      meta: {
        title: '坏账申请'
      },
      component: () => import('@/views/sell/personageManagement/components/contractList/badDebtApplication')
    },
    {
      path: 'badDebtDetails',
      name: 'badDebtDetails',
      meta: {
        title: '坏账详情'
      },
      component: () => import('@/views/sell/personageManagement/components/contractList/badDebtDetails')
    },
    {
      path: 'contractReturnMoneyTransfer',
      name: 'contractReturnMoneyTransfer',
      meta: {
        title: '合同回款划拨'
      },
      component: () => import('@/views/sell/personageManagement/contractReturnMoneyTransfer')
    },
    {
      path: 'sellStockRecord',
      name: 'sellStockRecord',
      meta: {
        title: '备货产品清单'
      },
      component: () => import('@/views/sell/personageManagement/sellStockRecord')
    },
    {
      path: 'sellStockSponsor',
      name: 'sellStockSponsor',
      meta: {
        title: '发起备货'
      },
      component: () => import('@/views/sell/personageManagement/components/sellStockSponsor')
    },
    {
      path: 'sellShipmentsRecord',
      name: 'sellShipmentsRecord',
      meta: {
        title: '发货产品清单'
      },
      component: () => import('@/views/sell/personageManagement/sellShipmentsRecord')
    },
    {
      path: 'sellShipments',
      name: 'sellShipments',
      meta: {
        title: '发起发货'
      },
      component: () => import('@/views/sell/personageManagement/components/sellShipments')
    },
    {
      path: 'contractInvoicingManagement',
      name: 'contractInvoicingManagement',
      meta: {
        title: '开票产品清单'
      },
      component: () => import('@/views/sell/personageManagement/contractInvoicingManagement')
    },
    {
      path: 'sellInvoice',
      name: 'sellInvoice',
      meta: {
        title: '申请开票'
      },
      component: () => import('@/views/sell/personageManagement/components/sellInvoice')
    },
    {
      path: 'sellRecordcount',
      name: 'sellRecordcount',
      meta: {
        title: '销售备发货开票记录'
      },
      component: () => import('@/views/sell/personageManagement/sellRecordcount')
    },
    {
      path: 'afterSaleRecord',
      name: 'afterSaleRecord',
      meta: {
        title: '售后记录'
      },
      component: () => import('@/views/sell/personageManagement/afterSaleRecord')
    },
    {
      path: 'badDebtRecord',
      name: 'badDebtRecord',
      meta: {
        title: '坏账记录'
      },
      component: () => import('@/views/sell/personageManagement/badDebtRecord')
    },
    {
      path: 'customerWithdrawalRecord',
      name: 'customerWithdrawalRecord',
      meta: {
        title: '客户提现记录'
      },
      component: () => import('@/views/sell/personageManagement/customerWithdrawalRecord')
    },
    {
      path: 'initiateWithdrawal',
      name: 'initiateWithdrawal',
      meta: {
        title: '发起提现'
      },
      component: () => import('@/views/sell/personageManagement/components/customer/initiateWithdrawal')
    },
    {
      path: 'withdrawalDetails',
      name: 'withdrawalDetails',
      meta: {
        title: '提现详情'
      },
      component: () => import('@/views/sell/personageManagement/components/customer/withdrawalDetails')
    },
    {
      path: 'sellCommissionStatistics',
      name: 'sellCommissionStatistics',
      meta: {
        title: '销售佣金统计'
      },
      component: () => import('@/views/sell/personageManagement/sellCommissionStatistics')
    },
    {
      path: 'contractEdit',
      name: 'contractEdit',
      meta: {
        title: '合同详情'
      },
      component: () => import('@/views/sell/personageManagement/components/contractList/contractEdit')
    },
    {
      path: 'contractContrast',
      name: 'contractContrast',
      meta: {
        title: '合同对比'
      },
      component: () => import('@/views/sell/personageManagement/components/contractList/contractContrast')
    },
    {
      path: 'contractCreate',
      name: 'contractCreate',
      meta: {
        title: '合同详情'
      },
      component: () => import('@/views/sell/personageManagement/components/contractList/contractCreate')
    },
    {
      path: 'contractPreview',
      name: 'contractPreview',
      meta: {
        title: '合同预览'
      },
      component: () => import('@/views/purchase/purchaseManage/components/contract/contractPreview')
    },
    {
      path: 'sponsorReportLack',
      name: 'sponsorReportLack',
      meta: {
        title: '发起报缺'
      },
      component: () => import('@/views/sell/personageManagement/components/contractList/sponsorReportLack')
    },
    {
      path: 'nitiateStockUp',
      name: 'nitiateStockUp',
      meta: {
        title: '发起备货'
      },
      component: () => import('@/views/sell/personageManagement/components/stockUp/nitiateStockUp')
    },
    {
      path: 'stockUpEdit',
      name: 'stockUpEdit',
      meta: {
        title: '备货详情'
      },
      component: () => import('@/views/sell/personageManagement/components/stockUp/stockUpEdit')
    },
    {
      path: 'startShipments',
      name: 'startShipments',
      meta: {
        title: '发起发货'
      },
      component: () => import('@/views/sell/personageManagement/components/shipments/startShipments')
    },
    {
      path: 'shipmentsEdit',
      name: 'shipmentsEdit',
      meta: {
        title: '发货详情'
      },
      component: () => import('@/views/sell/personageManagement/components/shipments/shipmentsEdit')
    },
    {
      path: 'applyForMakeOutAnInvoice',
      name: 'applyForMakeOutAnInvoice',
      meta: {
        title: '申请开票'
      },
      component: () => import('@/views/sell/personageManagement/components/billManage/applyForMakeOutAnInvoice')
    },
    {
      path: 'applyForReturnTicket',
      name: 'applyForReturnTicket',
      meta: {
        title: '申请退票'
      },
      component: () => import('@/views/sell/personageManagement/components/billManage/applyForReturnTicket')
    },
    {
      path: 'redApplyForReturnTicket',
      name: 'redApplyForReturnTicket',
      meta: {
        title: '申请红字发票'
      },
      component: () => import('@/views/sell/personageManagement/components/billManage/applyForReturnTicket')
    },
    {
      path: 'makeOutAnInvoiceEdit',
      name: 'makeOutAnInvoiceEdit',
      meta: {
        title: '开票详情'
      },
      component: () => import('@/views/sell/personageManagement/components/billManage/makeOutAnInvoiceEdit')
    },
    {
      path: 'returnTicketEdit',
      name: 'returnTicketEdit',
      meta: {
        title: '退票详情'
      },
      component: () => import('@/views/sell/personageManagement/components/billManage/returnTicketEdit')
    },
    {
      path: 'sellSalesReturn',
      name: 'sellSalesReturn',
      meta: {
        title: '发起退货'
      },
      component: () => import('@/views/sell/personageManagement/components/afterSaleManage/sellSalesReturn')
    },
    {
      path: 'sellSalesReturnEdit',
      name: 'sellSalesReturnEdit',
      meta: {
        title: '退货详情'
      },
      component: () => import('@/views/sell/personageManagement/components/afterSaleManage/sellSalesReturnEdit'),
      children: [{
        path: 'salesProgram',
        name: 'salesProgram',
        meta: {
          title: '退货方案'
        },
        component: () => import('@/views/sell/personageManagement/components/afterSaleManage/salesProgram')
      },
      {
        path: 'salesRefundLogistics',
        name: 'salesRefundLogistics',
        meta: {
          title: '物流管理'
        },
        component: () => import('@/views/sell/personageManagement/components/afterSaleManage/salesRefundLogistics')
      },
      {
        path: 'salesRefundContract',
        name: 'salesRefundContract',
        meta: {
          title: '合同管理'
        },
        component: () => import('@/views/sell/personageManagement/components/afterSaleManage/salesRefundContract')
      },
      {
        path: 'confiscatedInvoice',
        name: 'confiscatedInvoice',
        meta: {
          title: '罚没金开票'
        },
        component: () => import('@/views/sell/personageManagement/components/afterSaleManage/confiscatedInvoice')
      },
      {
        path: 'salesRefundSettlement',
        name: 'salesRefundSettlement',
        meta: {
          title: '退款结算'
        },
        component: () => import('@/views/sell/personageManagement/components/afterSaleManage/salesRefundSettlement')
      }]
    },
    {
      path: 'transferEdit',
      name: 'transferEdit',
      meta: {
        title: '划拨详情'
      },
      component: () => import('@/views/sell/personageManagement/components/contractReturnTransfer/transferEdit')
    }
    ]
  },
  {
    path: 'teamManagement',
    name: 'teamManagement',
    meta: {
      title: '团队销售'
    },
    redirect: '/sell/teamManagement/teamQuotationRecord',
    component: View,
    children: [{
      path: 'teamQuotationRecord',
      name: 'teamQuotationRecord',
      meta: {
        title: '团队报价记录'
      },
      component: () => import('@/views/sell/teamManagement/teamQuotationRecord')
    },
    {
      path: 'teamSpecialOfferApproveRecord',
      name: 'teamSpecialOfferApproveRecord',
      meta: {
        title: '团队特价审批记录'
      },
      component: () => import('@/views/sell/teamManagement/teamSpecialOfferApproveRecord')
    },
    {
      path: 'teamContractRecord',
      name: 'teamContractRecord',
      meta: {
        title: '团队合同记录'
      },
      component: () => import('@/views/sell/teamManagement/teamContractRecord')
    },
    {
      path: 'teamDebtContractRecord',
      name: 'teamDebtContractRecord',
      meta: {
        title: '团队欠款合同清单'
      },
      component: () => import('@/views/sell/teamManagement/teamDebtContractRecord')
    },
    {
      path: 'teamStockRecord',
      name: 'teamStockRecord',
      meta: {
        title: '团队备货记录'
      },
      component: () => import('@/views/sell/teamManagement/teamStockRecord')
    },
    {
      path: 'teamShipmentsRecord',
      name: 'teamShipmentsRecord',
      meta: {
        title: '团队发货记录'
      },
      component: () => import('@/views/sell/teamManagement/teamShipmentsRecord')
    },
    {
      path: 'teamInvoiceRecord',
      name: 'teamInvoiceRecord',
      meta: {
        title: '团队开票记录'
      },
      component: () => import('@/views/sell/teamManagement/teamInvoiceRecord')
    },
    {
      path: 'teamWithdrawDepositRecord',
      name: 'teamWithdrawDepositRecord',
      meta: {
        title: '团队提现记录'
      },
      component: () => import('@/views/sell/teamManagement/teamWithdrawDepositRecord')
    },
    {
      path: 'teamMaintainRecord',
      name: 'teamMaintainRecord',
      meta: {
        title: '团队维修记录'
      },
      component: () => import('@/views/sell/teamManagement/teamMaintainRecord')
    },
    {
      path: 'teamSalesReturnRecord',
      name: 'teamSalesReturnRecord',
      meta: {
        title: '团队退货记录'
      },
      component: () => import('@/views/sell/teamManagement/teamSalesReturnRecord')
    },
    {
      path: 'teamBadDebtRecord',
      name: 'teamBadDebtRecord',
      meta: {
        title: '团队坏账管理'
      },
      component: () => import('@/views/sell/teamManagement/teamBadDebtRecord')
    },
    {
      path: 'teamPerformanceManage',
      name: 'teamPerformanceManage',
      meta: {
        title: '团队业绩管理'
      },
      component: () => import('@/views/sell/teamManagement/teamPerformanceManage')
    }
    ]
  }
  ]
},
{
  path: '/purchase',
  component: MainView,
  name: 'purchaseex',
  meta: {
    title: '采购管理'
  },
  icon: 'el-icon-menu',
  redirect: '/purchase/purchaseManage/waitFeedbackEnquiryList',
  children: [{
    path: 'purchaseManage',
    name: 'purchaseManage',
    meta: {
      title: '采购管理'
    },
    redirect: '/purchase/purchaseManage/waitFeedbackEnquiryList',
    component: View,
    children: [{
      path: 'waitFeedbackEnquiryList',
      name: 'waitFeedbackEnquiryList',
      meta: {
        title: '待反馈询价列表'
      },
      component: () => import('@/views/purchase/purchaseManage/waitFeedbackEnquiryList')
    },
    {
      path: 'inquiryProductDetails',
      name: 'inquiryProductDetails',
      meta: {
        title: '询价产品详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/inquiry/inquiryProductDetails')
    },
    {
      path: 'inquiryResultDetails',
      name: 'inquiryResultDetails',
      meta: {
        title: '询价结果'
      },
      component: () => import('@/views/purchase/purchaseManage/components/inquiry/inquiryResultDetails')
    },
    {
      path: 'distributionDetails',
      name: 'distributionDetails',
      meta: {
        title: '配货详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/distribution/distributionDetails')
    },
    {
      path: 'distributionResult',
      name: 'distributionResult',
      meta: {
        title: '配货结果'
      },
      component: () => import('@/views/purchase/purchaseManage/components/distribution/distributionResult')
    },
    {
      path: 'supplierRechargeOn',
      name: 'supplierRechargeOn',
      meta: {
        title: '供应商-发起充值'
      },
      component: () => import('@/views/purchase/purchaseManage/supplierRecharge')
    },
    {
      path: 'waitAllocateCargoList',
      name: 'waitAllocateCargoList',
      meta: {
        title: '待配货列表'
      },
      component: () => import('@/views/purchase/purchaseManage/waitAllocateCargoList')
    },
    {
      path: 'purchasePlanList',
      name: 'purchasePlanList',
      meta: {
        title: '采购清单'
      },
      component: () => import('@/views/purchase/purchaseManage/purchasePlanList')
    },
    {
      path: 'purchasePlanDetails',
      name: 'purchasePlanDetails',
      meta: {
        title: '采购计划详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/purchasePlanList/purchasePlanDetails')
    },
    {
      path: 'purchaseContractList',
      name: 'purchaseContractList',
      meta: {
        title: '采购合同列表'
      },
      component: () => import('@/views/purchase/purchaseManage/purchaseContractList')
    },
    {
      path: 'createContract',
      name: 'createContract',
      meta: {
        title: '生成合同'
      },
      component: () => import('@/views/purchase/purchaseManage/components/contract/createContract')
    },
    {
      path: 'contractDetails',
      name: 'contractDetails',
      meta: {
        title: '合同详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/contract/contractDetails')
    },
    {
      path: 'afterSaleReturn',
      name: 'afterSaleReturn',
      meta: {
        title: '发起退货'
      },
      component: () => import('@/views/purchase/purchaseManage/components/afterSalesManage/salesReturn')
    },
    {
      path: 'salesReturnDetail',
      name: 'salesReturnDetail',
      meta: {
        title: '退货详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/afterSalesManage/salesReturnDetail')
    },
    {
      path: 'initiateLossReporting',
      name: 'initiateLossReporting',
      meta: {
        title: '发起报缺'
      },
      component: () => import('@/views/purchase/purchaseManage/components/contract/initiateLossReporting')
    },
    {
      path: 'initiateShipment',
      name: 'initiateShipment',
      meta: {
        title: '发起发货'
      },
      component: () => import('@/views/purchase/purchaseManage/components/deliveryManage/initiateShipment')
    },
    {
      path: 'shipmentDetails',
      name: 'shipmentDetails',
      meta: {
        title: '发货详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/deliveryManage/shipmentDetails')
    },
    {
      path: 'applyForTicketCollection',
      name: 'applyForTicketCollection',
      meta: {
        title: '申请收票'
      },
      component: () => import('@/views/purchase/purchaseManage/components/billManage/applyForTicketCollection')
    },
    {
      path: 'ticketCollectionDetails',
      name: 'ticketCollectionDetails',
      meta: {
        title: '收票详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/billManage/ticketCollectionDetails')
    },
    {
      path: 'redApplyForRefund',
      name: 'redApplyForRefund',
      meta: {
        title: '申请退票'
      },
      component: () => import('@/views/purchase/purchaseManage/components/billManage/redApplyForRefund')
    },
    {
      path: 'redApplyForTicketCollection',
      name: 'redApplyForTicketCollection',
      meta: {
        title: '申请收票'
      },
      component: () => import('@/views/purchase/purchaseManage/components/billManage/redApplyForTicketCollection')
    },
    {
      path: 'refundDetails',
      name: 'refundDetails',
      meta: {
        title: '退票详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/billManage/refundDetails')
    },
    {
      path: 'purchaseShipmentsRecord',
      name: 'purchaseShipmentsRecord',
      meta: {
        title: '采购发货记录'
      },
      component: () => import('@/views/purchase/purchaseManage/purchaseShipmentsRecord')
    },
    {
      path: 'waitGatheringSupplierList',
      name: 'waitGatheringSupplierList',
      meta: {
        title: '待支付供应商列表'
      },
      component: () => import('@/views/purchase/purchaseManage/waitGatheringSupplierList')
    },
    {
      path: 'contractPreview',
      name: 'contractPreviewLook',
      meta: {
        title: '合同预览'
      },
      component: () => import('@/views/purchase/purchaseManage/components/contract/contractPreview')
    },
    {
      path: 'SupplierRechargeRecord',
      name: 'SupplierRechargeRecord',
      meta: {
        title: '供应商充值记录'
      },
      component: () => import('@/views/purchase/purchaseManage/SupplierRechargeRecord')
    },
    {
      path: 'supplierPayDetial',
      name: 'supplierPayDetial',
      meta: {
        title: '充值详情'
      },
      component: () => import('@/views/purchase/purchaseManage/supplierPayDetial')
    },
    {
      path: 'payApplication',
      name: 'payApplication',
      meta: {
        title: '采购付款申请'
      },
      component: () => import('@/views/purchase/purchaseManage/components/waitPaySupplier/payApplication')
    },
    {
      path: 'paymentDetails',
      name: 'paymentDetails',
      meta: {
        title: '付款详情'
      },
      component: () => import('@/views/purchase/purchaseManage/components/waitPaySupplier/paymentDetails')
    },
    {
      path: 'afterSalesRepairList',
      name: 'afterSalesRepairList',
      meta: {
        title: '售后维修列表'
      },
      component: () => import('@/views/purchase/purchaseManage/afterSalesRepairList')
    },
    {
      path: 'waitSplitSalesReturnApply',
      name: 'waitSplitSalesReturnApply',
      meta: {
        title: '待处理退货产品列表'
      },
      component: () => import('@/views/purchase/purchaseManage/waitSplitSalesReturnApply')
    },
    {
      path: 'waitSplitSalesReturnDetail',
      name: 'waitSplitSalesReturnDetail',
      meta: {
        title: '退货申请详情'
      },
      component: () => import('@/views/purchase/purchaseManage/waitSplitSalesReturnDetail')
    },
    {
      path: 'purchasecontractContrast',
      name: 'purchasecontractContrast',
      meta: {
        title: '合同对比'
      },
      component: () => import('@/views/sell/personageManagement/components/contractList/contractContrast')
    },
    {
      path: 'salesReturnPlanList',
      name: 'salesReturnPlanList',
      meta: {
        title: '退货计划列表'
      },
      component: () => import('@/views/purchase/purchaseManage/salesReturnPlanList')
    },
    {
      path: 'salesReturnTaskList',
      name: 'salesReturnTaskList',
      meta: {
        title: '退货任务列表'
      },
      component: () => import('@/views/purchase/purchaseManage/salesReturnTaskList')
    },
    {
      path: 'notChecksContractList',
      name: 'notChecksContractList',
      meta: {
        title: '未收票合同列表'
      },
      component: () => import('@/views/purchase/purchaseManage/notChecksContractList')
    }
    ]
  },
  {
    path: 'teamManage',
    name: 'teamManage',
    meta: {
      title: '团队管理'
    },
    redirect: '/purchase/teamManage/teamEnquiryRecord',
    component: View,
    children: [{
      path: 'teamEnquiryRecord',
      name: 'teamEnquiryRecord',
      meta: {
        title: '团队询价记录'
      },
      component: () => import('@/views/purchase/teamManage/teamEnquiryRecord')
    },
    {
      path: 'teamStockupRecord',
      name: 'teamStockupRecord',
      meta: {
        title: '团队备货记录'
      },
      component: () => import('@/views/purchase/teamManage/teamStockupRecord')
    },
    {
      path: 'teamPurchasePlanRecord',
      name: 'teamPurchasePlanRecord',
      meta: {
        title: '团队采购计划记录'
      },
      component: () => import('@/views/purchase/teamManage/teamPurchasePlanRecord')
    },
    {
      path: 'teamPurchaseContractRecord',
      name: 'teamPurchaseContractRecord',
      meta: {
        title: '团队采购合同记录'
      },
      component: () => import('@/views/purchase/teamManage/teamPurchaseContractRecord')
    },
    {
      path: 'teamPurchaseShipmentsRecord',
      name: 'teamPurchaseShipmentsRecord',
      meta: {
        title: '团队发货记录'
      },
      component: () => import('@/views/purchase/teamManage/teamPurchaseShipmentsRecord')
    },
    {
      path: 'teamRepairRecord',
      name: 'teamRepairRecord',
      meta: {
        title: '团队维修记录'
      },
      component: () => import('@/views/purchase/teamManage/teamRepairRecord')
    },
    {
      path: 'teamSalesReturnApplyRecord',
      name: 'teamSalesReturnApplyRecord',
      meta: {
        title: '团队退货申请记录'
      },
      component: () => import('@/views/purchase/teamManage/teamSalesReturnApplyRecord')
    },
    {
      path: 'teamSalesReturnPlanRecord',
      name: 'teamSalesReturnPlanRecord',
      meta: {
        title: '团队退货计划记录'
      },
      component: () => import('@/views/purchase/teamManage/teamSalesReturnPlanRecord')
    },
    {
      path: 'teamSalesReturnTaskRecord',
      name: 'teamSalesReturnTaskRecord',
      meta: {
        title: '团队退货任务记录'
      },
      component: () => import('@/views/purchase/teamManage/teamSalesReturnTaskRecord')
    },
    {
      path: 'teamChecksRecord',
      name: 'teamChecksRecord',
      meta: {
        title: '团队收票记录'
      },
      component: () => import('@/views/purchase/teamManage/teamChecksRecord')
    },
    {
      path: 'teamStockupRecordDemo',
      name: 'teamStockupRecordDemo',
      meta: {
        title: '测试'
      },
      component: () => import('@/views/purchase/teamManage/demo')
    }
    ]
  }
  ]
},
{
  path: '/finance',
  component: MainView,
  name: 'finance',
  meta: {
    title: '财务管理'
  },
  icon: 'el-icon-menu',
  redirect: '/finance/financeManage/waitAuditPayApplyList',
  children: [{
    path: 'financeManage',
    name: 'financeManage',
    meta: {
      title: '财务管理'
    },
    redirect: '/finance/financeManage/waitAuditPayApplyList',
    component: View,
    children: [{
      path: 'acceptDraftCollections',
      name: 'acceptDraftCollections',
      meta: {
        title: '承兑汇票收款'
      },
      component: () => import('@/views/sell/personageManagement/acceptDraftCollections')
    },
    {
      path: 'initiateCollection',
      name: 'initiateCollection',
      meta: {
        title: '发起收款'
      },
      component: () => import('@/views/sell/personageManagement/components/acceptDraftCollections/initiateCollection')
    },
    {
      path: 'collectionApplicationDetails',
      name: 'collectionApplicationDetails',
      meta: {
        title: '收款申请详情'
      },
      component: () => import('@/views/sell/personageManagement/components/acceptDraftCollections/collectionApplicationDetails')
    }, {
      path: 'waitAuditPayApplyList',
      name: 'waitAuditPayApplyList',
      meta: {
        title: '待审核付款申请'
      },
      component: () => import('@/views/finance/financeManage/waitAuditPayApplyList')
    },
    {
      path: 'finishApplyList',
      name: 'finishApplyList',
      meta: {
        title: '待审核详情'
      },
      component: () => import('@/views/finance/financeManage/components/waitAuditApply/finishApplyList')
    },
    {
      path: 'cliaminList',
      name: 'cliaminList',
      meta: {
        title: '待审核详情'
      },
      component: () => import('@/views/finance/financeManage/components/waitAuditApply/cliaminList')
    },
    {
      path: 'overcliaminList',
      name: 'overcliaminList',
      meta: {
        title: '待审核付款申请详情'
      },
      component: () => import('@/views/finance/financeManage/components/waitAuditApply/overcliaminList')
    },
    {
      path: 'waitDisposePayApplyList',
      name: 'waitDisposePayApplyList',
      meta: {
        title: '待处理申请列表'
      },
      component: () => import('@/views/finance/financeManage/waitDisposePayApplyList')
    },
    {
      path: 'waitbankdetailed',
      name: 'waitbankdetailed',
      meta: {
        title: '银行转账待处理详情'
      },
      component: () => import('@/views/finance/financeManage/components/waitDisposePList/waitbankdetailed')
    },
    {
      path: 'waitBilldetailed',
      name: 'waitBilldetailed',
      meta: {
        title: '承兑汇票待处理详情'
      },
      component: () => import('@/views/finance/financeManage/components/waitDisposePList/waitBilldetailed')
    },
    {
      path: 'overBilldetailed',
      name: 'overBilldetailed',
      meta: {
        title: '待处理详情'
      },
      component: () => import('@/views/finance/financeManage/components/waitDisposePList/overBilldetailed')
    }, {
      path: 'AuditedList',
      name: 'AuditedList',
      meta: {
        title: '我的已处理详情'
      },
      component: () => import('@/views/finance/financeManage/components/waitDisposePList/AuditedList')
    },
    {
      path: 'bankCollectionList',
      name: 'bankCollectionList',
      meta: {
        title: '银行对账单收款管理'
      },
      component: () => import('@/views/finance/financeManage/bankCollectionList')
    },
    {
      path: 'dealList',
      name: 'dealList',
      meta: {
        title: '银行对账单收款管理详情'
      },
      component: () => import('@/views/finance/financeManage/components/bankCollect/dealList')
    },
    {
      path: 'passList',
      name: 'passList',
      meta: {
        title: '银行对账不通过详情'
      },
      component: () => import('@/views/finance/financeManage/components/bankCollect/passList')
    },
    {
      path: 'CollectionList',
      name: 'CollectionList',
      meta: {
        title: '银行对账单收款管理详情'
      },
      component: () => import('@/views/finance/financeManage/components/bankCollect/CollectionList')
    },
    {
      path: 'otherCollectionList',
      name: 'otherCollectionList',
      meta: {
        title: '其他收款'
      },
      component: () => import('@/views/finance/financeManage/otherCollectionList')
    },
    {
      path: 'otherList',
      name: 'otherList',
      meta: {
        title: '其他收款'
      },
      component: () => import('@/views/finance/financeManage/components/otherCollection/otherList')
    }, {
      path: 'collectionDetails',
      name: 'collectionDetails',
      meta: {
        title: '收款记录详情'
      },
      component: () => import('@/views/finance/financeManage/components/otherCollection/collectionDetails')
    }, {
      path: 'auditDetails',
      name: 'auditDetails',
      meta: {
        title: '其他收款详情'
      },
      component: () => import('@/views/finance/financeManage/components/otherCollection/auditDetails')
    },
    {
      path: 'acceptDraftCollectionsManage',
      name: 'acceptDraftCollectionsManage',
      meta: {
        title: '承兑汇票收款管理'
      },
      component: () => import('@/views/finance/financeManage/acceptDraftCollectionsManage')
    }, {
      path: 'acceptDraftManage',
      name: 'acceptDraftManage',
      meta: {
        title: '承兑汇票管理'
      },
      component: () => import('@/views/finance/financeManage/acceptDraftManage')
    },
    {
      path: 'billLook',
      name: 'billLook',
      meta: {
        title: '承兑汇票管理'
      },
      component: () => import('@/views/finance/financeManage/components/acceptDraft/billLook')
    },
    {
      path: 'passlook',
      name: 'passlook',
      meta: {
        title: '承兑汇票管理'
      },
      component: () => import('@/views/finance/financeManage/components/acceptDraft/passlook')
    }, {
      path: 'dealwith',
      name: 'dealwith',
      meta: {
        title: '承兑汇票管理'
      },
      component: () => import('@/views/finance/financeManage/components/acceptDraft/dealwith')
    }, {
      path: 'acceplist',
      name: 'acceplist',
      meta: {
        title: '承兑汇票管理'
      },
      component: () => import('@/views/finance/financeManage/components/accceptBill/acceplist')
    },
    {
      path: 'addbill',
      name: 'addbill',
      meta: {
        title: '添加承兑汇票'
      },
      component: () => import('@/views/finance/financeManage/components/acceptDraft/addbill')
    },
    {
      path: 'financeInvoiceManage',
      name: 'financeInvoiceManage',
      meta: {
        title: '财务开票管理'
      },
      component: () => import('@/views/finance/financeManage/financeInvoiceManage')
    }, {
      path: 'finandetails',
      name: 'finandetails',
      meta: {
        title: '财务开票管理'
      },
      component: () => import('@/views/finance/financeManage/components/finandetails')
    },
    {
      path: 'financeChecksManage',
      name: 'financeChecksManage',
      meta: {
        title: '财务收票管理'
      },
      component: () => import('@/views/finance/financeManage/financeChecksManage')
    }, {
      path: 'TicketCollection',
      name: 'TicketCollection',
      meta: {
        title: '财务收票详情'
      },
      component: () => import('@/views/finance/financeManage/components/TicketCollection')
    },
    {
      path: 'commonReturnTicketApplyList',
      name: 'commonReturnTicketApplyList',
      meta: {
        title: '普通发票退票管理'
      },
      component: () => import('@/views/finance/financeManage/commonReturnTicketApplyList')
    }, {
      path: 'redReturnTicketApplyList',
      name: 'redReturnTicketApplyList',
      meta: {
        title: '红字发票退票管理'
      },
      component: () => import('@/views/finance/financeManage/commonReturnTicketApplyList')
    }, {
      path: 'commonReturnbank', // 审核 处理  详情
      name: 'commonReturnbank',
      meta: {
        title: '退票详情'
      },
      component: () => import('@/views/finance/financeManage/components/commonReturnbank')
    }, {
      path: 'financeManageSet',
      name: 'financeManageSet',
      meta: {
        title: '财务管理设置'
      },
      component: () => import('@/views/finance/financeManage/financeManageSet')
    },
    {
      path: 'balanceManage',
      name: 'balanceManage',
      meta: {
        title: '余额管理'
      },
      component: () => import('@/views/finance/financeManage/balanceManage')
    },
    {
      path: 'notes',
      name: 'notes',
      meta: {
        title: '收支记录'
      },
      component: () => import('@/views/finance/financeManage/components/bananceList/notes')
    },
    {
      path: 'badManagement',
      name: 'badManagement',
      meta: {
        title: '坏账管理'
      },
      component: () => import('@/views/finance/financeManage/badManagement')
    },
    {
      path: 'baddetails',
      name: 'baddetails',
      meta: {
        title: '坏账详情'
      },
      component: () => import('@/views/finance/financeManage/components/badApply/baddetails')
    },
    {
      path: 'LogExprSet',
      name: 'LogExprSet',
      meta: {
        title: '物流&快递费用结算'
      },
      component: () => import('@/views/finance/financeManage/LogExprSet')
    },
    {
      path: 'haveDebt',
      name: 'haveDebt',
      meta: {
        title: '欠款客户'
      },
      component: () => import('@/views/finance/financeManage/haveDebt')
    }

    ]
  }]
},
{
  path: '/storage',
  component: MainView,
  name: 'storage',
  meta: {
    title: '仓储管理'
  },
  icon: 'el-icon-menu',
  redirect: '/storage/storageManage/inventoryStockList',
  children: [{
    path: 'storageManage',
    name: 'storageManage',
    meta: {
      title: '仓储管理'
    },
    redirect: '/storage/storageManage/inventoryStockList',
    component: View,
    children: [{
      path: 'inventoryStockList',
      name: 'inventoryStockList',
      meta: {
        title: '库存备货列表'
      },
      component: () => import('@/views/storage/storageManage/inventoryStockList')
    },
    {
      path: 'stockDetail',
      name: 'stockDetail',
      meta: {
        title: '备货详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/stockDetail')
    },
    {
      path: 'stockMigrationList',
      name: 'stockMigrationList',
      meta: {
        title: '备货详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/stockMigrationList')
    },
    {
      path: 'stockDetails',
      name: 'stockDetails',
      meta: {
        title: '备货详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/stockDetail')
    },
    {
      path: 'stockProcessed',
      name: 'stockProcessed',
      meta: {
        title: '备货详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/stockProcessed')
    },
    {
      path: 'logisticsShipmentsList',
      name: 'logisticsShipmentsList',
      meta: {
        title: '物流发货列表'
      },
      component: () => import('@/views/storage/storageManage/logisticsShipmentsList')
    },
    {
      path: 'shipmentDetail',
      name: 'shipmentDetail',
      meta: {
        title: '物流发货详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/shipmentDetail')
    },
    {
      path: 'oneselfExtractShipmentsList',
      name: 'oneselfExtractShipmentsList',
      meta: {
        title: '自提发货列表'
      },
      component: () => import('@/views/storage/storageManage/oneselfExtractShipmentsList')
    },
    {
      path: 'oneselfDetail',
      name: 'oneselfDetail',
      meta: {
        title: '自提发货详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/oneselfDetail')
    },
    {
      path: 'warehouseShipmentsList',
      name: 'warehouseShipmentsList',
      meta: {
        title: '仓库发货列表'
      },
      component: () => import('@/views/storage/storageManage/warehouseShipmentsList')
    },
    {
      path: 'wearhouseDetial',
      name: 'wearhouseDetial',
      meta: {
        title: '仓库发货详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/wearhouseDetial')
    },

    {
      path: 'logisticsGoToWarehouseList',
      name: 'logisticsGoToWarehouseList',
      meta: {
        title: '物流入库列表'
      },
      component: () => import('@/views/storage/storageManage/logisticsGoToWarehouseList')
    },
    {
      path: 'logisticsGoToDetail',
      name: 'logisticsGoToDetail',
      meta: {
        title: '物流入库详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/logisticsGoToDetail')
    },
    {
      path: 'logisticsWareDetail',
      name: 'logisticsWareDetail',
      meta: {
        title: '物流入库已处理详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/logisticsWareDetail')
    },
    {
      path: 'distributionGoToWarehouseList',
      name: 'distributionGoToWarehouseList',
      meta: {
        title: '配送入库列表'
      },
      component: () => import('@/views/storage/storageManage/distributionGoToWarehouseList')
    },
    {
      path: 'distributionGoToDetail',
      name: 'distributionGoToDetail',
      meta: {
        title: '配送入库详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/distributionGoToDetail')
    },
    {
      path: 'distributionDetail',
      name: 'distributionDetail',
      meta: {
        title: '配送入库已处理详情页'
      },
      component: () => import('@/views/storage/storageManage/detail/distributionDetail')
    },
    {
      path: 'wareHouseSetting',
      name: 'wareHouseSetting',
      meta: {
        title: '仓库设置'
      },
      component: () => import('@/views/storage/storageManage/wareHouseSetting')
    },
    {
      path: 'shelfManagement',
      name: 'shelfManagement',
      meta: {
        title: '货架管理'
      },
      component: () => import('@/views/storage/storageManage/shelfManagement')
    },
    {
      path: 'openingInventory',
      name: 'openingInventory',
      meta: {
        title: '期初库存'
      },
      component: () => import('@/views/storage/storageManage/openingInventory')
    },
    {
      path: 'realTimeInventory',
      name: 'realTimeInventoryex',
      meta: {
        title: '实时库存查询'
      },
      component: () => import('@/views/storage/storageManage/realTimeInventory')
    },
    {
      path: 'incabinTransfer',
      name: 'incabinTransfer',
      meta: {
        title: '仓内调拨'
      },
      component: () => import('@/views/storage/storageManage/incabinTransfer')
    },
    {
      path: 'inventoryCheckWarehouseList',
      name: 'inventoryCheckWarehouseList',
      meta: {
        title: '库存盘点'
      },
      component: () => import('@/views/storage/storageManage/inventoryCheckWarehouseList')
    },
    {
      path: 'inventoryDetail',
      name: 'inventoryDetail',
      meta: {
        title: '库存盘点详情'
      },
      component: () => import('@/views/storage/storageManage/detail/inventoryDetail')
    },
    {
      path: 'inventoryOderDetail',
      name: 'inventoryOderDetail',
      meta: {
        title: '盘点单详情'
      },
      component: () => import('@/views/storage/storageManage/detail/inventoryOderDetail')
    },
    {
      path: 'openInventory',
      name: 'openInventory',
      meta: {
        title: '盘点'
      },
      component: () => import('@/views/storage/storageManage/detail/openInventory')
    },
    {
      path: 'procuctRecords',
      name: 'procuctRecords',
      meta: {
        title: '产品盈亏记录'
      },
      component: () => import('@/views/storage/storageManage/procuctRecords')
    },
    {
      path: 'pendingInventoryTasks',
      name: 'pendingInventoryTasks',
      meta: {
        title: '待审核盘点任务'
      },
      component: () => import('@/views/storage/storageManage/pendingInventoryTasks')
    },
    {
      path: 'reviewInventoryDetail',
      name: 'reviewInventoryDetail',
      meta: {
        title: '待审核盘点任务详情'
      },
      component: () => import('@/views/storage/storageManage/detail/reviewInventoryDetail')
    },
    {
      path: 'lockLibraryException',
      name: 'lockLibraryException',
      meta: {
        title: '待处理锁库异常'
      },
      component: () => import('@/views/storage/storageManage/lockLibraryException')
    },
    {
      path: 'historyQuery',
      name: 'historyQuery',
      meta: {
        title: '历史出入库查询'
      },
      component: () => import('@/views/storage/storageManage/historyQuery')
    }
    ]
  }]
},
{
  path: '/system',
  component: MainView,
  name: 'system',
  meta: {
    title: '系统设置'
  },
  icon: 'el-icon-menu',
  redirect: '/system/systemSet/expressLogisticsCompanyList',
  children: [{
    path: 'systemSet',
    name: 'systemSet',
    meta: {
      title: '系统设置'
    },
    redirect: '/system/systemSet/expressLogisticsCompanyList',
    component: View,
    children: [
      ...systemList
    ]
  },
  {
    path: 'authorityManagement',
    name: 'authorityManagement',
    meta: {
      title: '权限管理'
    },
    redirect: '/system/authorityManagement/roleManagement',
    component: View,
    children: [{
      path: 'roleManagement',
      name: 'roleManagementex',
      meta: {
        title: '角色管理'
      },
      component: () => import('@/views/system/authorityManagement/roleManagement')
    },
    {
      path: 'authorityManagementList',
      name: 'authorityManagementList',
      meta: {
        title: '权限管理'
      },
      component: () => import('@/views/system/authorityManagement/authorityManagementList')
    },
    {
      path: 'staffManagement',
      name: 'staffManagement',
      meta: {
        title: '员工管理'
      },
      component: () => import('@/views/system/authorityManagement/staffManagement')
    }
    ]
  },
  {
    path: 'otherManage',
    name: 'otherManage',
    meta: {
      title: '其他管理'
    },
    redirect: '/system/otherManage/systemLog',
    component: View,
    children: [{
      path: 'codingManage',
      name: 'codingManage',
      meta: {
        title: '编码管理'
      },
      component: () => import('@/views/system/otherManage/codingManage')
    },
    {
      path: 'propertyClass',
      name: 'propertyClass',
      meta: {
        title: '属性分类'
      },
      component: () => import('@/views/system/otherManage/propertyClass')
    },
    {
      path: 'systemLog',
      name: 'systemLog',
      meta: {
        title: '系统日志'
      },
      component: () => import('@/views/system/otherManage/systemLog')
    }
    ]
  }
  ]
},
{
  path: '/data',
  component: MainView,
  name: 'data',
  meta: {
    title: '数据报表'
  },
  icon: 'el-icon-menu',
  redirect: '/data/sell',
  children: [{
    path: 'sell',
    name: 'sell',
    meta: {
      title: '销售'
    },
    redirect: '/data/sell/dailySalesReport',
    component: View,
    children: [{
      path: 'dailySalesReport',
      name: 'dailySalesReport',
      meta: {
        title: '销售日报表'
      },
      component: () => import('@/views/data/sell/dailySalesReport')
    },
    {
      path: 'monthlySalesReport',
      name: 'monthlySalesReport',
      meta: {
        title: '销售月报表'
      },
      component: () => import('@/views/data/sell/monthlySalesReport')
    }, {
      path: 'customerSalesStatistics',
      name: 'customerSalesStatistics',
      meta: {
        title: '客户销售统计'
      },
      component: () => import('@/views/data/sell/customerSalesStatistics')
    },
    {
      path: 'salesPerformanceStatistics',
      name: 'salesPerformanceStatistics',
      meta: {
        title: '销售业绩统计'
      },
      component: () => import('@/views/data/sell/salesPerformanceStatistics')
    },
    {
      path: 'salesLacksDetails',
      name: 'salesLacksDetails',
      meta: {
        title: '销售报缺明细'
      },
      component: () => import('@/views/data/sell/salesLacksDetails')
    },
    {
      path: 'salesReturnStatistics',
      name: 'salesReturnStatistics',
      meta: {
        title: '销售退货统计'
      },
      component: () => import('@/views/data/sell/salesReturnStatistics')
    },
    {
      path: 'salesMaintenanceDetails',
      name: 'salesMaintenanceDetails',
      meta: {
        title: '销售维修明细'
      },
      component: () => import('@/views/data/sell/salesMaintenanceDetails')
    }, {
      path: 'productSalesStatistics',
      name: 'productSalesStatistics',
      meta: {
        title: '产品销售统计'
      },
      component: () => import('@/views/data/sell/productSalesStatistics')
    },
    {
      path: 'salesShipmentsList',
      name: 'salesShipmentsList',
      meta: {
        title: '销售发货表'
      },
      component: () => import('@/views/data/sell/salesShipmentsList')
    },
    {
      path: 'salesPerformanceStatement',
      name: 'salesPerformanceStatement',
      meta: {
        title: '销售业绩表'
      },
      component: () => import('@/views/data/sell/salesPerformanceStatement')
    }]
  }, {
    path: 'purchase',
    name: 'purchase',
    meta: {
      title: '采购'
    },
    redirect: '/data/purchase/dailyPurchaseReport',
    component: View,
    children: [{
      path: 'dailyPurchaseReport',
      name: 'dailyPurchaseReport',
      meta: {
        title: '采购日报表'
      },
      component: () => import('@/views/data/purchase/dailyPurchaseReport')
    },
    {
      path: 'monthlyPurchaseReport',
      name: 'monthlyPurchaseReport',
      meta: {
        title: '采购月报表'
      },
      component: () => import('@/views/data/purchase/monthlyPurchaseReport')
    },
    {
      path: 'productPurchaseStatistics',
      name: 'productPurchaseStatistics',
      meta: {
        title: '产品采购统计'
      },
      component: () => import('@/views/data/purchase/productPurchaseStatistics')
    },
    {
      path: 'supplierSupplyStatistics',
      name: 'supplierSupplyStatistics',
      meta: {
        title: '供应商供货统计'
      },
      component: () => import('@/views/data/purchase/supplierSupplyStatistics')
    },
    {
      path: 'purchaseReturnDetails',
      name: 'purchaseReturnDetails',
      meta: {
        title: '采购退货统计'
      },
      component: () => import('@/views/data/purchase/purchaseReturnDetails')
    },
    {
      path: 'purchaseMaintenanceDetails',
      name: 'purchaseMaintenanceDetails',
      meta: {
        title: '采购维修明细'
      },
      component: () => import('@/views/data/purchase/purchaseMaintenanceDetails')
    },
    {
      path: 'purchaseLacksDetails',
      name: 'purchaseLacksDetails',
      meta: {
        title: '采购报缺明细'
      },
      component: () => import('@/views/data/purchase/purchaseLacksDetails')
    },
    {
      path: 'procurementCostSavingsStatistics',
      name: 'procurementCostSavingsStatistics',
      meta: {
        title: '采购节约成本统计'
      },
      component: () => import('@/views/data/purchase/procurementCostSavingsStatistics')
    },
    {
      path: 'productPurchaseReminder',
      name: 'productPurchaseReminder',
      meta: {
        title: '采购产品提醒'
      },
      component: () => import('@/views/data/purchase/productPurchaseReminder')
    },
    {
      path: 'purchaseInquiryReport',
      name: 'purchaseInquiryReport',
      meta: {
        title: '采购询价报表'
      },
      component: () => import('@/views/data/purchase/purchaseInquiryReport')
    }]
  },
  {
    path: 'finance',
    name: 'financeex',
    meta: {
      title: '财务'
    },
    redirect: '/data/finance/bankPaymentStatistics',
    component: View,
    children: [{
      path: 'bankPaymentStatistics',
      name: 'bankPaymentStatistics',
      meta: {
        title: '银行付款统计'
      },
      component: () => import('@/views/data/finance/bankPaymentStatistics')
    },
    {
      path: 'acceptanceBillPaymentStatistics',
      name: 'acceptanceBillPaymentStatistics',
      meta: {
        title: '承兑汇票付款统计'
      },
      component: () => import('@/views/data/finance/acceptanceBillPaymentStatistics')
    },
    {
      path: 'bankCollectionStatistics',
      name: 'bankCollectionStatistics',
      meta: {
        title: '银行收款统计'
      },
      component: () => import('@/views/data/finance/bankCollectionStatistics')
    },
    {
      path: 'acceptanceBillCollectionStatistics',
      name: 'acceptanceBillCollectionStatistics',
      meta: {
        title: '承兑汇票收款统计'
      },
      component: () => import('@/views/data/finance/acceptanceBillCollectionStatistics')
    },
    {
      path: 'summarySheetPayable',
      name: 'summarySheetPayable',
      meta: {
        title: '应付汇总表'
      },
      component: () => import('@/views/data/finance/summarySheetPayable')
    },
    {
      path: 'summarySheetReceivables',
      name: 'summarySheetReceivables',
      meta: {
        title: '应收汇总表'
      },
      component: () => import('@/views/data/finance/summarySheetReceivables')
    },
    {
      path: 'badSubsidiary',
      name: 'badSubsidiary',
      meta: {
        title: '坏账明细'
      },
      component: () => import('@/views/data/finance/badSubsidiary')
    },
    {
      path: 'summarySheetInvoicing',
      name: 'summarySheetInvoicing',
      meta: {
        title: '开票汇总表'
      },
      component: () => import('@/views/data/finance/summarySheetInvoicing')
    },
    {
      path: 'summarySheetReceipts',
      name: 'summarySheetReceipts',
      meta: {
        title: '收票汇总表'
      },
      component: () => import('@/views/data/finance/summarySheetReceipts')
    },
    {
      path: 'summarySheetGeneralRefund',
      name: 'summarySheetGeneralRefund',
      meta: {
        title: '普通退票汇总表'
      },
      component: () => import('@/views/data/finance/summarySheetGeneralRefund')
    },
    {
      path: 'summarySheetCreditNoteRefund',
      name: 'summarySheetCreditNoteRefund',
      meta: {
        title: '红字发票退票汇总表'
      },
      component: () => import('@/views/data/finance/summarySheetCreditNoteRefund')
    },
    {
      path: 'logisticsCostStatistics',
      name: 'logisticsCostStatistics',
      meta: {
        title: '物流费用统计表'
      },
      component: () => import('@/views/data/finance/logisticsCostStatistics')
    },
    {
      path: 'summarySheetUnInvoicedBills',
      name: 'summarySheetUnInvoicedBills',
      meta: {
        title: '未开票汇总表'
      },
      component: () => import('@/views/data/finance/summarySheetUnInvoicedBills')
    },
    {
      path: 'SummaryUncollectedBills',
      name: 'SummaryUncollectedBills',
      meta: {
        title: '未收票汇总表'
      },
      component: () => import('@/views/data/finance/SummaryUncollectedBills')
    },
    {
      path: 'discountStatements',
      name: 'discountStatements',
      meta: {
        title: '贴现报表'
      },
      component: () => import('@/views/data/finance/discountStatements')
    },
    {
      path: 'costOfSalesStatement',
      name: 'costOfSalesStatement',
      meta: {
        title: '销售成本表'
      },
      component: () => import('@/views/data/finance/costOfSalesStatement')
    },
    {
      path: 'collectionSummary',
      name: 'collectionSummary',
      meta: {
        title: '收款汇总表'
      },
      component: () => import('@/views/data/finance/collectionSummary')
    },
    {
      path: 'paymentSummary',
      name: 'paymentSummary',
      meta: {
        title: '付款汇总表'
      },
      component: () => import('@/views/data/finance/paymentSummary')
    }]
  },
  {
    path: 'storage',
    name: 'storageex',
    meta: {
      title: '仓储'
    },
    redirect: '/data/storage/inventoryOutList',
    component: View,
    children: [{
      path: 'inventoryOutList',
      name: 'inventoryOutList',
      meta: {
        title: '出库明细表'
      },
      component: () => import('@/views/data/storage/inventoryOutList')
    },
    {
      path: 'inventoryEntryList',
      name: 'inventoryEntryList',
      meta: {
        title: '入库明细表'
      },
      component: () => import('@/views/data/storage/inventoryEntryList')
    }, {
      path: 'profitList',
      name: 'profitList',
      meta: {
        title: '仓储盈亏报表'
      },
      component: () => import('@/views/data/storage/profitList')
    },
    {
      path: 'realTimeInventory',
      name: 'realTimeInventory',
      meta: {
        title: '实时库存'
      },
      component: () => import('@/views/data/storage/realTimeInventory')
    },
    {
      path: 'inventorySummaryList',
      name: 'inventorySummaryList',
      meta: {
        title: '库存汇总表'
      },
      component: () => import('@/views/data/storage/inventorySummaryList')
    },
    {
      path: 'stockUpList',
      name: 'stockUpList',
      meta: {
        title: '仓储备货表'
      },
      component: () => import('@/views/data/storage/stockUpList')
    }]

  },
  {
    path: 'crm',
    name: 'crm',
    meta: {
      title: 'CRM'
    },
    redirect: '/data/crm/customerBalance',
    component: View,
    children: [{
      path: 'customerBalance',
      name: 'customerBalance',
      meta: {
        title: '客户余额统计'
      },
      component: () => import('@/views/data/crm/customerBalance')
    },
    {
      path: 'supplierBalance',
      name: 'supplierBalance',
      meta: {
        title: '供应商余额统计'
      },
      component: () => import('@/views/data/crm/supplierBalance')
    }]
  }
  ]
}

]

const router = new VueRouter({
  routes
})

export default router
